import { render } from "./online-module.vue?vue&type=template&id=4c340288"
import script from "./online-module.vue?vue&type=script&lang=js"
export * from "./online-module.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__